<!--
 * @Author: 黄贺林
 * @Date: 2024-06-27 14:30:55
 * @LastEditTime: 2024-08-23 18:34:29
 * @Description: 在此处清晰,简洁的说明本文件的作用
-->
 <template>
   <div class="login-page" v-loading="$store.getters.GET_LOADING">
        <div class="login-page-title">
            <div>{{ $t('welcome_anycubic_slicer') }}</div>
            <div>{{ $t('add_printers_manage_jobs') }}</div>
        </div>
        <div class="login-page-main">
            <div class="login-page-main-item">
                <img src="@/assets/imgs/remote-printing.png" alt="">
                <div class="login-page-main-item-title">{{ $t('remote_printing') }}</div>
                <div class="login-page-main-item-describe">{{ $t('connect_printer_slicer_wan') }}</div>
            </div>
            <div class="login-page-main-item">
                <img src="@/assets/imgs/get-notifications.png" alt="">
                <div class="login-page-main-item-title">{{ $t('get_notifications') }}</div>
                <div class="login-page-main-item-describe">{{ $t('receive_notifications') }}</div>
            </div>
            <div class="login-page-main-item">
                <img src="@/assets/imgs/video-monitor.png" alt="">
                <div class="login-page-main-item-title">{{ $t('video_monitor') }}</div>
                <div class="login-page-main-item-describe">{{ $t('video_monitor_real_time') }}</div>
            </div>
        </div>
        <div class="login-page-btn-box">
            <div class="login-page-btn"  @click="loginHandle">{{ $t('Login') }}</div>
            <div class="login-page-btn" @click="addDialog = true">{{ $t('AddPrinter') }}</div>
        </div>
        <addPrinter :visible.sync="addDialog"></addPrinter>
   </div>
 </template>

<script>
import addPrinter from '@/views/components/dialog/addPrinter.vue'
// import { onAccountEvent } from '@/utils/account'
import { account,getLogin } from '@/utils/account'
export default {
    components: {
        addPrinter
    },
    data() { 
        return {
            addDialog: false,
        }
    },
    mounted() { 
        getLogin()
    },
    methods: {
        loginHandle() {
           account.login()
            // casdoor登录
            // window.location.href = this.getSigninUrl();
        },
    },
}    
</script>
<style lang="scss" scoped>
.login-page{
    overflow: hidden;
    border-image-source: url(@/assets/imgs/login-background.png);
    border-image-slice: 10 fill;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    position: relative;
    .login-page-title{
        width: 919px;
        height: 124px;
        margin: 94px 0 73px 0;
        color: #4D4D4D;

        div:first-of-type{
            height: 84px;
            font-weight: normal;
            font-size: 30px;
            line-height: 84px;
            text-align: center;
            font-family: AlibabaPuHuiTi-3-85-Bold;
        }
        div:last-of-type{
            height: 24px;
            font-family: AlibabaPuHuiTi-3-55-Regular;
            font-weight: 400;
            font-size: 20px;
            line-height: 24px;
            text-align: center;
        }
    } 

    .login-page-main{
        width: 1438px;
        height: 312px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .login-page-main-item{
            width: 450px;
            height: 312px;
            text-align: center;
            img{
                width: 200px;
                height: 200px;
            }
            .login-page-main-item-title{
                height: 28px;
                font-family: AlibabaPuHuiTi-3-85-Bold;
                font-size: 20px;
                color: #4D4D4D;
                height: 28px;
                margin: 16px 0 24px 0;
            }
            .login-page-main-item-describe{
                font-family: AlibabaPuHuiTi-3-55-Regular;
                font-size: 16px;
                color: #4D4D4D;
                height: 19px;
                line-height: 19px;
            }
        }
    }
    .login-page-btn-box{
        margin-top: 90px;
        font-family: AlibabaPuHuiTi-3-55-Regular;
        .login-page-btn{
            font-size: 15px;
            width: 450px;
            height: 40px;
            line-height: 40px;
            background: #3986FF;
            color: #ffff;
            border-radius: 6px 6px 6px 6px;
            text-align: center;
            cursor: pointer;
        }
        .login-page-btn:last-of-type{
            border: 1px solid #3986FF;
            background: none;
            color: #438DFF;
            margin-top: 10px;
        }
    }

}
@media screen and (max-height: 800px) {
   .login-page-btn-box{
    bottom: 30px;
    position: absolute;
   }
   .login-page-btn-box :last-of-type{
    background:rgb(232,250,255) !important;
   }
}
</style>
